import { atom } from 'jotai';
import type { hintsBlock } from '@/enums';

export const hintsAtom = atom<{
    block: hintsBlock | null;
    item: string | null;
}>({ block: null, item: null });
